import React from 'react';
import PropTypes from 'prop-types';

import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import { Box, TopbarWrapper } from '../design/css';

import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const DevicesTable = ({ devices, onDelete }) => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    devicesTable: { deviceLabel, priceLabel, quantityLabel, deleteLabel },
    formButtons: { deleteButtonLabel }
  } = localizedStrings;
  const totlDevices = devices.reduce((acc, item) => acc + +item.quantity, 0);

  return (
    <Box
      style={{
        margin: '2rem 0',
        border: '1px solid #e3e3e3',
        boxShadow: '1px 1px 9px 4px #e3e3e3'
      }}
    >
      <TopbarWrapper
        style={{ color: '#fff' }}
      >{`Total Devices (${totlDevices})`}</TopbarWrapper>
      <Table>
        <Thead style={{ background: '#e2e2e2' }}>
          <Tr>
            <Th>#</Th>
            <Th>{deviceLabel}</Th>
            <Th>{priceLabel}</Th>
            <Th>{quantityLabel}</Th>
            <Th>{deleteLabel}</Th>
          </Tr>
        </Thead>
        <Tbody>
          {devices.map((item, index) => {
            const { name: device, unitPrice, quantity } = item;
            const rowKey = `row${index}`;

            return (
              <Tr
                key={rowKey}
                style={{
                  background: index % 2 === 0 ? '#f9f1ff' : '#ffffff'
                }}
              >
                <Td width="10%">{index + 1}</Td>
                <Td width="40%">{device}</Td>
                <Td width="15%">{`$${unitPrice}`}</Td>
                <Td width="15%">{quantity}</Td>
                <Td width="20%">
                  <button
                    type="button"
                    className="btn btn-link"
                    style={{ color: '#4B286D', textDecoration: 'underline' }}
                    onClick={() => onDelete(index)}
                  >
                    {deleteButtonLabel}
                  </button>
                </Td>
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Box>
  );
};

DevicesTable.propTypes = {
  devices: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      unitPrice: PropTypes.number,
      quantity: PropTypes.number
    })
  ).isRequired,
  onDelete: PropTypes.func.isRequired
};

export default DevicesTable;
